import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { OperatingStandardService } from "../../services/operating-standard.service";
import { Router } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { StepsControllerService } from "../../services/steps-controller.service";
import { UserService } from "../../services/user.service";
import { NotificationsService } from "../../services/notifications.service";
import * as moment from "moment";
import { SidebarService } from "../../services/side-bar.service";
import { TaskBarService } from "../../services/task-bar.service";
import { FabMessageService } from "../../services/fab-message.service";
import { AuthService } from "../../services/auth.service";
import { ReportDatepickerComponent } from "../../modals/report-datepicker.component";
import { ReportType } from "../../models/report-type.model";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "../../models/user.model";

@Component({
  selector: "app-operating-standard",
  templateUrl: "./operating-standard.component.html",
  styleUrls: ["./operating-standard.component.css"]
})
export class OperatingStandardComponent implements OnInit {
  activeList = 1;
  requiredActionList: any = [];
  standardsList: any = [];
  suggestionLists: any = [];
  isLoaded = false;
  errorMessage = false;
  sortOrdersStnd: string[] = [];
  sortOrdersSuggest: string[] = [];
  displayingStandards: any = [];
  displayingSuggestions: any = [];
  displayingStandardsViewed: any = [];
  displayingSuggestViewed: any = [];
  selectedSortOrderStnd = "ALL";
  selectedSortOrderSuggest = "ALL";
  sortedSuggestionsTable: any = [];
  sortOrder: any = null;
  currentSortField: string | null = null;
  generalNotify;
  karma = false;
  show = false;
  title = 'Show all notifications'
  mobWidth: any;
  mainGroup: any;
  isAdmin = false;
	isUser = false;
	isHead = false;
  public user: User;
  allHeadGroups;

  constructor(
    private operatingStandardService: OperatingStandardService,
    private router: Router,
    private adminService: AdminService,
    private notificationsService: NotificationsService,
    public stepsControllerService: StepsControllerService,
    public userService: UserService,
    public sidebarService: SidebarService,
    public taskbarService: TaskBarService,
    public fabService: FabMessageService,
    public authService: AuthService,
    private modalService: NgbModal
  ) {

    this.mobWidth = window.innerWidth;

    const getWindow = () => {
      return window.innerWidth;
    };

    window.onresize = () => {
      this.mobWidth = getWindow();
    };
   }

  ngOnInit() {
   this.mainGroup = JSON.parse(localStorage.getItem('User')).mainGroup;
   this.user = this.userService.getLocal();
    this.getGeneralNotify(this.userService.getLocal().id);
    this.isLoaded = false;
    this.errorMessage = false;
    this.operatingStandardService
      .getOperatingStandsNotificationsAPITemp()
      .subscribe(
        (res: any) => {
          if (res.status === 200) {
            const allNotificationLists = res.body;

            if (allNotificationLists.hasOwnProperty("GLOBAL")) {
              allNotificationLists.GLOBAL.forEach(gs => {
                this.requiredActionList.push(gs);
              });
            }

            if (allNotificationLists.hasOwnProperty("SUGGESTION")) {
              allNotificationLists.SUGGESTION.forEach(ss => {
                this.requiredActionList.push(ss);
              });
            }

            if (allNotificationLists.hasOwnProperty("SUGGESTION_ACTION")) {
              allNotificationLists.SUGGESTION_ACTION.forEach(sas => {
                this.requiredActionList.push(sas);
              });
            }

            if (allNotificationLists.hasOwnProperty("SUGGESTION_CANCEL")) {
              allNotificationLists.SUGGESTION_CANCEL.forEach(scs => {
                this.requiredActionList.push(scs);
              });
            }

            if (this.requiredActionList.length > 0) {
              this.sortNotifications();
            } else {
              this.isLoaded = true;
            }
          } else if (res.status === 204) {
            this.requiredActionList = [];
            this.standardsList = [];
            this.suggestionLists = [];
            this.isLoaded = true;
          }
        },
        () => {
          this.isLoaded = true;
          this.errorMessage = true;
          this.requiredActionList = [];
        }
      );
      if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
        this.isHead = true;
        this.getAllGroups();
      }
  }

  getAllGroups() {
    this.adminService.getGroupsAndPositionsHead().subscribe(
      (res: any) => {
        if (res.status === 200) {
          this.allHeadGroups = res.body;
        }
      }
    )
  }

  open(id) {
		const modalRef = this.modalService.open(ReportDatepickerComponent);
		modalRef.componentInstance.reportType = ReportType.BY_VACATION;
		modalRef.componentInstance.userId = id;
	}

  shoeList() {
    if (this.show) {
      this.show = false;
      this.title = 'Show all notifications'
    } else {
      this.show = true;
      this.title = 'Hide read notifications'
    }
  }

  signOut() {
    this.userService.writeLogoutTime().subscribe(
      (response: any) => {
        this.fabService.showFab(1);
        this.userService.deleteLocal();
        this.authService.signOut();
      },
      (error: any) => {
        if (error.status === 400) {
          this.fabService.showFab(2);
          this.userService.deleteLocal();
          this.authService.signOut();
        }
      }
    );
  }

  disableLogout(): boolean {
    return this.userService.getLocal().testing;
  }

  recordSignOutTime() {
    this.userService.writeLogoutTime().subscribe(
      (response: any) => {
        this.fabService.showFab(1);
      },
      (error: any) => {
        if (error.status === 400) {
          this.fabService.showFab(2);
        }
      }
    );
  }

  getGeneralNotify(id) {
    this.operatingStandardService.getGeneralNoitify(id)
      .subscribe(
        (res: any) => {
          this.generalNotify = res.body;
          this.generalNotify.forEach(groupNode => {
            if (groupNode.create) {
              groupNode.create = groupNode.create.split('T')[0];

            }
            if (groupNode.source) {
              this.karma = true;
            }
            if (~groupNode.description.indexOf('http')) {
              groupNode.link = ('http' + groupNode.description.split("http")[1]).toString();
              groupNode.description = groupNode.description.split("http")[0];
            }
          });
        },
        () => {
          this.isLoaded = true;
          this.errorMessage = true;
          this.requiredActionList = [];
        }
      );

  }

  getDate(tmsp) {
    return moment.utc(tmsp).format("DD/MM/YYYY");
  }

  sortNotifications() {
    if (this.requiredActionList.length > 0) {
      this.requiredActionList.forEach(i => {
        if (i.hasOwnProperty("standardNumber") && i.status !== "INACTIVE") {
          this.standardsList.push(i);
        }
        if (i.hasOwnProperty("suggestionId") && i.status !== "INACTIVE") {
          this.suggestionLists.push(i);
        }
      });
      this.setDaysField(this.standardsList);
      this.setDaysField(this.suggestionLists);
      const sortStndParams = [];
      const sortSuggestParams = [];
      for (let i = 0; i < this.standardsList.length; i++) {
        sortStndParams.push(this.standardsList[i].type);
      }
      for (const str of sortStndParams) {
        if (!this.sortOrdersStnd.includes(str)) {
          this.sortOrdersStnd.push(str);
        }
      }
      for (let i = 0; i < this.suggestionLists.length; i++) {
        sortSuggestParams.push(this.suggestionLists[i].type);
      }
      for (const str of sortSuggestParams) {
        if (!this.sortOrdersSuggest.includes(str)) {
          this.sortOrdersSuggest.push(str);
        }
      }
      this.displayingStandards = this.standardsList;
      this.displayingSuggestions = this.suggestionLists;
      this.isLoaded = true;
    }
    this.displayingStandards.reverse();
    this.displayingSuggestions.reverse();

    this.displayingStandards.forEach(i => {
      if (i.viewed === true) {
        this.displayingStandardsViewed.unshift(i);
        this.displayingStandards = this.displayingStandards.filter(
          el => el.viewed === false
        );
      }
    });
    this.displayingSuggestions.forEach(i => {
      if (i.viewed === true) {
        this.displayingSuggestViewed.unshift(i);
        this.displayingSuggestions = this.displayingSuggestions.filter(
          el => el.viewed === false
        );
      }
    });

    this.sortedSuggestionsTable = [
      ...this.displayingSuggestions,
      ...this.displayingSuggestViewed
    ];
  }

  setDaysField(list) {
    list.forEach(item => {
      if (item.expiringDate !== "") {
        const expiringDateConst = moment(item.expiringDate).startOf("day");
        const currentDate = moment().startOf("day");
        item.days = expiringDateConst.diff(currentDate, "days");
      }
    });

    this.isLoaded = true;
  }

  setActiveList(i) {
    this.activeList = i;
  }

  // OK
  // ADDED_SUGGESTION_FOR_REVIEW
  // SUGGESTION_CANCELLED
  // SUGGESTION_IMPLEMENTED
  // SUGGESTION_POSTPONED
  // SUGGESTION_REASSIGNED
  // SUGGESTION_POSTPONE_EXPIRED
  // ALL_SUGGESTION_TASKS_DONE
  // SUGGESTION_TASK_WORK
  // SUGGESTION_TASKS_EXPIRED
  openNotification(stnd, type = null) {
    let sID = "";
    let sType = "";
    let sStatus = "";
    let slID = "";
    const itemId = stnd.id;
    // Check Notification type
    switch (stnd.category) {
      case "GLOBAL":
        sID = stnd.standardId;
        sType = stnd.type;
        sStatus = stnd.status;
        slID = "";
        break;
      case "SUGGESTION":
        sID = "";
        sType = stnd.type;
        sStatus = stnd.status;
        slID = stnd.suggestionId;
        break;
      case "SUGGESTION_ACTION":
        // has result
        sID = "";
        sType = stnd.type;
        sStatus = stnd.status;
        slID = stnd.suggestionId;
        break;
      case "SUGGESTION_CANCEL":
        // has reason
        sID = "";
        sType = stnd.type;
        sStatus = stnd.status;
        slID = stnd.suggestionId;
        break;
    }

    if (type === "stnd") {
      const sendingParams = {
        id: itemId,
        notificationCategory: "STANDARD"
      };
      localStorage.setItem('notificationCategory', JSON.stringify(sendingParams));
      localStorage.setItem('standartType', stnd.type);
      this.adminService.notifyIsView(sendingParams).subscribe(
        (response: any) => { },
        () => {
          this.isLoaded = false;
        }
      );
    }
    if (type === "sl") {
      const sendingParams = {
        id: itemId,
        notificationCategory: "SUGGESTION"
      };
      this.adminService.notifyIsView(sendingParams).subscribe(
        (response: any) => { },
        () => {
          this.isLoaded = false;
        }
      );
    }
    if (type === "slsl") {
      const sendingParams = {
        id: itemId,
        notificationCategory: "NOTIFICATION_GENERAL"
      };
      this.adminService.notifyIsView(sendingParams).subscribe(
        (response: any) => {
          this.getGeneralNotify(this.userService.getLocal().id);
        },
        () => {
          this.isLoaded = false;
        }
      );
    }

    // смотреть на тип и перенаправлять куда нужно
    switch (sType) {
      case "CONFIRMATION_STARTED":
        this.router.navigate(["/dashboard/confirm-standard/" + sID]);
        break;
      case "MODIFY_REQUEST":
        this.stepsControllerService.setNotifyType("MODIFY_REQUEST");
        this.modifyActionDo(sID, true, "MODIFY_REQUEST", "STNDR");
        break;
      case "CONFIRMATION_FINISHED":
        this.stepsControllerService.setNotifyType("CONFIRMATION_FINISHED");
        this.modifyActionDo(sID, true, "CONFIRMATION_FINISHED", "STNDR");
        break;
      case "CONF_CHAT_MESSAGE":
        this.modifyActionDo(sID, true, "CONF_CHAT_MESSAGE", "STNDR");
        break;
      case "FAMILIARIZATION_STARTED":
        this.router.navigate(["/dashboard/familiarize-standard/" + sID]);
        break;
      case "FAMILIARIZATION_FINISHED":
        this.stepsControllerService.setNotifyType("FAMILIARIZATION_FINISHED");
        this.modifyActionDo(sID, true, "FAMILIARIZATION_FINISHED", "STNDR");
        break;
      case "MODIFICATION_DONE":
        this.router.navigate(["/dashboard/confirm-standard/" + sID]);
        break;
      case "TESTING_STARTED":
        this.router.navigate(["/dashboard/familiarize-standard/" + sID]);
        break;
      case "TRANSLATED_MAIN_INFO_DONE":
        this.stepsControllerService.setNotifyType("CONFIRMATION_FINISHED");
        this.modifyActionDo(sID, true, "CONFIRMATION_FINISHED", "STNDR");
        break;
      case "TRANSLATION_COMPLETED":
        this.stepsControllerService.setNotifyType("FAMILIARIZATION_FINISHED");
        this.modifyActionDo(sID, true, "FAMILIARIZATION_FINISHED", "STNDR");
        break;
      case "ADDED_SUGGESTION_FOR_REVIEW":
        this.modifyActionDo(slID, true, "ADDED_SUGGESTION_FOR_REVIEW", "SL");
        break;
      case "SUGGESTION_CANCELLED":
        this.modifyActionDo(slID, true, "SUGGESTION_CANCELLED", "SL");
        break;
      case "SUGGESTION_APPROVE_CANCELLED":
        this.modifyActionDo(slID, true, "SUGGESTION APPROVE CANCELLED", "SL");
        break;
      case "SUGGESTION_IMPLEMENTED":
        this.modifyActionDo(slID, true, "SUGGESTION_IMPLEMENTED", "SL");
        break;
      case "SUGGESTION_POSTPONED":
        this.modifyActionDo(slID, true, "SUGGESTION_POSTPONED", "SL");
        break;
      case "SUGGESTION_REASSIGNED":
        this.modifyActionDo(slID, true, "SUGGESTION_REASSIGNED", "SL");
        break;
      case "SUGGESTION_POSTPONE_EXPIRED":
        this.modifyActionDo(slID, true, "SUGGESTION_POSTPONE_EXPIRED", "SL");
        break;
      case "ALL_SUGGESTION_TASKS_DONE":
        this.modifyActionDo(slID, true, "ALL_SUGGESTION_TASKS_DONE", "SL");
        break;
      case "SUGGESTION_TASK_WORK":
        this.modifyActionDo(slID, true, "SUGGESTION_TASK_WORK", "SL");
        break;
      case "SUGGESTION_TASKS_EXPIRED":
        this.modifyActionDo(slID, true, "SUGGESTION_TASK_WORK", "SL");
        break;
      case "NEW_MESSAGE":
        this.modifyActionDo(slID, true, "NEW_MESSAGE", "SL");
        break;
    }
  }

  modifyActionDo(sID, toSteps, status, objectTxt) {
    // IF STANDARD
    if (objectTxt === "STNDR") {
      this.adminService.getStandard(sID).subscribe(
        (response: any) => {
          this.errorMessage = false;
          if (response.status === 200) {
            const standard = response.body;

            if (status === "CONF_CHAT_MESSAGE") {
              this.router.navigate(["/dashboard/confirm-standard/" + sID]);
            } else {
              if (this.userService.getLocal().id === standard.author.id) {
                if (toSteps) {
                  this.stepsControllerService.setCurrentStandard(standard);
                }
              } else {
                this.router.navigate(["/dashboard/confirm-standard/" + sID]);
              }
            }
          }
        },
        () => {
          this.errorMessage = true;
        }
      );
    } else if (objectTxt === "SL") {
      // IF SL
      this.router.navigate(["/dashboard/suggestion-list-details/" + sID]);
    }
  }

  // OK
  // ADDED_SUGGESTION_FOR_REVIEW
  // SUGGESTION_CANCELLED
  // SUGGESTION_IMPLEMENTED
  // SUGGESTION_POSTPONED
  // SUGGESTION_REASSIGNED
  // SUGGESTION_POSTPONE_EXPIRED
  // ALL_SUGGESTION_TASKS_DONE
  // SUGGESTION_TASK_WORK
  // SUGGESTION_TASKS_EXPIRED
  setClass(type, status) {
    if (status === "ACTIVE") {
      switch (type) {
        case "CONFIRMATION_STARTED":
          return "notify-border-left-one";
        case "MODIFY_REQUEST":
          return "notify-border-left-two";
        case "CONFIRMATION_FINISHED":
          return "notify-border-left-three";
        case "CONF_CHAT_MESSAGE":
          return "notify-border-left-four";
        case "FAMILIARIZATION_STARTED":
          return "notify-border-left-five";
        case "FAMILIARIZATION_FINISHED":
          return "notify-border-left-six";
        case "MODIFICATION_DONE":
          return "notify-border-left-md";
        case "TESTING_STARTED":
          return "notify-border-left-ts";
        case "TRANSLATED_MAIN_INFO_DONE":
        case "TRANSLATION_COMPLETED":
          return "notify-border-left-translate";
        case "ADDED_SUGGESTION_FOR_REVIEW":
        case "SUGGESTION_CANCELLED":
        case "SUGGESTION_IMPLEMENTED":
        case "SUGGESTION_POSTPONED":
        case "SUGGESTION_REASSIGNED":
        case "SUGGESTION_POSTPONE_EXPIRED":
        case "ALL_SUGGESTION_TASKS_DONE":
        case "SUGGESTION_TASK_WORK":
        case "SUGGESTION_TASKS_EXPIRED":
          return "notify-border-left-sl";
      }
    } else {
      return "notify-border-left-sl";
    }
  }

  changeSortDirection(table, field) {
    this.sortOrder =
      this.sortOrder === "descending" ? "ascending" : "descending";

    switch (field) {
      case "initiator":
        if (this.sortOrder === "descending") {
          table.sort((a, b) =>
            a.source.fullName.localeCompare(b.source.fullName)
          );
        } else if (this.sortOrder === "ascending") {
          table.sort((a, b) =>
            b.source.fullName.localeCompare(a.source.fullName)
          );
        }

        break;

      case "date":
        if (this.sortOrder === "descending") {
          table.sort((a, b) =>
            a.timestamp.toString().localeCompare(b.timestamp.toString())
          );
        } else if (this.sortOrder === "ascending") {
          table.sort((a, b) =>
            b.timestamp.toString().localeCompare(a.timestamp.toString())
          );
        }
        break;

      case "status":
        if (this.sortOrder === "descending") {
          table.sort((a, b) => a.type.localeCompare(b.type));
        } else if (this.sortOrder === "ascending") {
          table.sort((a, b) => b.type.localeCompare(a.type));
        }
        break;
    }
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/operating-standard/operating-standard.component.ts